import { Block } from "baseui/block";
import { themedUseStyletron } from "../../../theme/customTheme";
import { OperationHours } from "../Aggregate/OperationHours";
import {  IFlapTwoPoint } from "./types";
import { LastXDaysLabel } from "../SensorDigital/LastXDaysLabel";
import { ObjectBooleanTimeline } from "../../../features/Charts/ObjectBooleanTimeline";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";



const InsightsPanel = (props: IFlapTwoPoint) => {
    const [css, theme] = themedUseStyletron()

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    return (<>
        {props.operationHours > 0 && <OperationHours {...props}></OperationHours>}
        <Block marginTop={theme.sizing.scale800}></Block>
        <LastXDaysLabel days={7}></LastXDaysLabel>
        <ObjectBooleanTimeline currentValue={props.isOn} onColor={theme.appColors.aggregate.on} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOn'}></ObjectBooleanTimeline>

    </>)
}

export default InsightsPanel